import { MessageToCode } from '../constants/FRConstants';

export interface IErrorOutcome {
  code?: string;
  customerRef?: string;
}

export const parse = (message: string | undefined): IErrorOutcome => {
  let toReturn = {} as IErrorOutcome;

  if (message) {
    const parts = message.split(`,`);
    toReturn = parts.reduce((accumulator, currentValue) => {
      const parsedPart = currentValue.split(`=`);
      return { ...accumulator, [parsedPart[0]]: parsedPart[1] };
    }, {});

    if (!toReturn.code && MessageToCode[message]) {
      toReturn = {
        code: MessageToCode[message]
      };
    }
  }
  return toReturn;
};
